import React from 'react';

import { Link } from 'react-router-dom';

import Types from '../../modules/types';

import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnFileName = {
  title: 'Name',
  render: record => record.name,
};

export const columnNameAdmin = {
  path: 'name',
  sort: 'name',
  width: '100%',
  link: '/products-imports/:_id',
};

export const columnNameSeller = {
  path: 'name',
  sort: 'name',
  width: '100%',
  link: '/store/products-imports/:_id',
};

export const columnStatus = {
  path: 'status',
  render: (record) => (
    <>
      {`${
        Types.PRODUCTS_IMPORT_STATUS_MAP[record.status]?.label
        || '-'
      }${
        record.limit > -1
        ? ` (first ${record.limit})`
        : ''
      }`}
    </>
  ),
};

export const columnProgress = {
  title: 'Progress',
  path: 'rows',
  render: (record) => {
    const {
      errors,
      // success,
      total,
    } = record.csv.rows.reduce(
      (agr, { error, generated }) => {
        if (error) {
          agr.errors++;
          agr.total++;
        } else if (generated) {
          agr.success++;
          agr.total++;
        }
        return agr;
      },
      { errors: 0, success: 0, total: 0 },
    );
    return `${
      total
    } / ${
      record.csv.rows.length
    }${
      errors > 0
      ? ` (${errors} ${errors === 1 ? 'error' : 'errors'})`
      : ''
    }`;
  },
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  render: (record) => (
    record.store?.name
    ? (
      <Link to={`/stores/${record.store._id}`}>
        {`${record.store?.name || 'N/A'}`}
      </Link>
    )
    : 'N/A'
  ),
};

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  columnStatus,
  // columnProgress,
  columnCreatedAt,
  columnUpdatedAt,
  // columnFileName,
];

export const SELLER = [
  columnNameSeller,
  columnStatus,
  // columnProgress,
  columnCreatedAt,
  columnUpdatedAt,
  // columnFileName,
];
